import { render, staticRenderFns } from "./BankPayment.vue?vue&type=template&id=42fc2064&"
import script from "./BankPayment.vue?vue&type=script&lang=js&"
export * from "./BankPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports